const setAlert = (alert) => ({
  type: 'SET_ALERT',
  alert,
})

export default setAlert